var React = require('react');

function RightPink (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#E990B0","fillRule":"evenodd","d":"M1518.18798,2362.27784 C1627.68141,2347.90929 1704.71829,2247.48923 1690.25504,2137.98331 C1675.79179,2028.47738 1575.30489,1951.35362 1465.81202,1965.72216 C1356.31859,1980.09071 1279.28171,2080.51131 1293.74496,2190.01669 C1308.20821,2299.52262 1408.69456,2376.64638 1518.18798,2362.27784","transform":"translate(-1292 -1970)"}));
}

RightPink.defaultProps = {"width":"148","height":"388","viewBox":"0 0 148 388"};

module.exports = RightPink;

RightPink.default = RightPink;
